import { createContext, useContext } from "react";
import { setPrintaction } from "../../../../redux/printstate/printActions";

type PrintSettings = {
  printAction: typeof setPrintaction;
  grabApi: string;
};

export const PrintSettingsContext = createContext<PrintSettings>({
  printAction: setPrintaction,
  grabApi: "/clinic/addBillDataGrabPosition",
});

export const usePrintSettings = () => useContext(PrintSettingsContext);
